.overlay {
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 40%);
  z-index: var(--z-store-switcher-overlay);
}

.form {
  position: relative;
}

.switcher {
  display: none;
  background-color: var(--bloom-colors-header-contrast);
  color: var(--bloom-colors-header-contrast-text-label);
  z-index: var(--z-store-switcher);
}

.switcher--expanded {
  display: flex;
  flex-direction: column;
  height: auto;
  inset: 0;
  max-height: 100%;
  overflow: hidden;
  padding: 0;
  position: fixed;
  width: 100%;
}

@media all and (--reefer-media-tablet-min) {
  .form {
    grid-area: switcher;
    align-self: end;
  }

  .switcher--expanded {
    border-radius: 24px;
    inset: auto auto auto 0;
    margin-top: 8px;
    max-height: calc(
      100dvh - calc(var(--header-height) + 8px + 16px)
    ); /* Header + header gap + page bottom gap */

    padding: 32px 32px 0;
    position: absolute;
    width: 495px;
  }
}
